import React, { useState } from "react";
import {
  CompleteAccountContainer,
  CompleteAccountWrapper,
  CompleteButtonContainer,
  CompleteH1,
  CompleteP1,
  CompleteP2,
  CompleteSetUp,
  HorizontalLine,
  NumberWrapper,
  Round,
} from "./complete.styles";
import Buttons from "../../../Button/button.component";
import { colors } from "../../../../theme/color";
import { FaArrowRight } from "react-icons/fa6";

const steps = [
  { number: "1", text: "Verify account" },
  { number: "2", text: "Add bank account" },
  { number: "3", text: "Secure your account" },
  { number: "4", text: "Tax" },
  { number: "5", text: "Review" },
];

const CompleteAccount = () => {
  const [state, setState] = React.useState(false);
  if (!state) return null;
  return (
    <CompleteAccountContainer>
      <div>
        <CompleteAccountWrapper>
          <CompleteH1>Complete account set-up</CompleteH1>
          <CompleteP1>
            Finish your account set up to have access to all our products
          </CompleteP1>
        </CompleteAccountWrapper>

        <CompleteSetUp>
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <NumberWrapper>
                <Round>{step.number}</Round>
                <CompleteP2>{step.text}</CompleteP2>
              </NumberWrapper>
              {index !== steps.length - 1 && <HorizontalLine></HorizontalLine>}
            </React.Fragment>
          ))}
        </CompleteSetUp>
      </div>
      <div>
        <CompleteButtonContainer>
          <Buttons
            label={
              <>
                <span>Get Started</span> <FaArrowRight />
              </>
            }
            width="149px"
            height="44px"
            cursor="pointer"
            border="10px"
            color={colors.neutral.cultured}
            textColor="green"
          />
        </CompleteButtonContainer>
      </div>
    </CompleteAccountContainer>
  );
};

export default CompleteAccount;
